document.addEventListener('DOMContentLoaded', function () {
  const shortWords = ['a', 'i', 'k', 'o', 's', 'u', 'v', 'z', 'na', 'do', 'od', 'po', 'za', 've', 'ke'];

  const elements = document.querySelectorAll(
    '.rte, .rte p, .page-content, .template-page, .article-template, .product__description, .collapsible-row, .featured-row__subtext, .textarea'
  );

  elements.forEach(function (element) {
    element.childNodes.forEach(function replaceText(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.nodeValue;

        shortWords.forEach(function (word) {
          const regex = new RegExp('(\\s|^)(' + word + ')\\s+', 'gi');
          text = text.replace(regex, '$1$2\u00A0');
        });

        node.nodeValue = text;
      } else if (
        node.nodeType === Node.ELEMENT_NODE &&
        !['SCRIPT', 'STYLE', 'BUTTON', 'A'].includes(node.tagName)
      ) {
        node.childNodes.forEach(replaceText);
      }
    });
  });
});